import React from "react";
import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";

export default function Wordpress() {
  return (
    <>
      <Navbar transparent />
      <section class="text-gray-600 body-font" id="Wordpress">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-col text-center w-full mb-20">
            <h2 class="text-xs text-indigo-500 tracking-widest font-medium title-font mb-1">
              Hire The Best Wordpress Developers
            </h2>
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-500">
              Hire The Best Wordpress Developers At Dave's Brother Technology
            </h1>
            <p class="lg:w-2/3 mx-auto leading-relaxed text-base">
              Kfrom Dave's  and give a push to your startup or business by
              developing cutting edge Angular.js apps. Powering millions of
              devices across the globe, we offer advanced Wordpress application
              development services.
            </p>
          </div>
          <div class="flex flex-col text-center w-full mb-20">
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
              Why Choose Dave's  For Wordpress Development?
            </h1>
          </div>
          <div class="flex flex-wrap">
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
              Round the Clock Support
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Be assured of round the clock support; our WordPress developers
                will address all the issues related to loading times and ensure
                efficient loading times.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Flexible Hiring
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Don’t want to hire full-time developers!!! No Problem. EC allows
                you to Hire Dedicated WordPress Developers. The assigned team
                will only work on your project, until it is done. After that,
                you can relieve them, and can easily alter your team size at any
                stage.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                Save Time & Money
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Hiring a dedicated WordPress developer from Dave's Brother Technology
                is cost-effective. Our hiring model best suits startups and
                SMEs.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
            <div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
              <h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
                100% Client Satisfaction
              </h2>
              <p class="leading-relaxed text-base mb-4">
                Here client satisfaction is the primary thing. If our client is
                not satisfied we too are not satisfied.
              </p>
              <a class="text-indigo-500 inline-flex items-center">
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  class="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section class="text-gray-600 body-font">
        <div class="flex flex-col text-center w-full mb-20">
          <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
            Benefits Of Choosing Wordpress For Your Company
          </h1>
        </div>
        <div class="container px-5 py-24 mx-auto flex flex-wrap">
          <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
            <img
              alt="feature"
              class="object-cover object-center mt-20-px h-300 w-300"
              src="https://engineerbabu.com/img/new/flutter/flutter_benefit.png"
            />
          </div>
          <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp; Blog or Personal Website{" "}
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                WordPress was specially created as a blogging platform. During these 15 years, WordPress has itself became more SEO friendly which makes WordPress as the most loved platform for building blogging sites.


                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp;Online Communities
                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                WordPress can be used to develop online communities even can add features like BuddyPress to your online forum.

</p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp; Auction Site e-Commerce website

                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                WordPress is the best fit for the e-Commerce and auction site where users can bid online, make payments, and you get to earn by merely providing a platform for your niche industry.


                </p>
              </div>
            </div>
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow">
                <h2 class="text-gray-900 text-lg title-font font-medium mb-3">
                  ● &nbsp;Business Website

                </h2>
                <p class="leading-relaxed text-base text-gray-900">
                WordPress is the optimal choice for developing any business site. It is so easy and simple to build a professional business website in WordPress. It gives you easy tools to quickly launch a website and then extend it as your business grows.


                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
